import React from "react";

const RadioGroup = ({
  label,
  description,
  name,
  options,
  register,
  required,
  layout = "horizontal",
  optional = false,
  value,
  onChange,
}) => {
  // Controlled mode: when value/onChange are supplied, drive the inputs
  // directly instead of registering with react-hook-form. Falls back to the
  // register-based path for every existing caller.
  const isControlled = typeof onChange === "function";
  return (
    <fieldset>
      <legend className="text-sm/6 font-medium text-ink-700">
        {label}
        {optional && (
          <span className="ml-1 font-normal text-ink-400">(optional)</span>
        )}
      </legend>
      {description && <p className="mt-1 text-sm/6 text-ink-500">{description}</p>}
      <div
        className={`mt-4 space-y-5 ${
          layout === "horizontal"
            ? "sm:flex sm:items-center sm:space-x-10 sm:space-y-0"
            : ""
        }`}
      >
        {options.map((option) => (
          <div key={option.id} className="flex items-start">
            <input
              {...(isControlled
                ? {
                    name,
                    checked: value === option.id,
                    onChange: () => onChange(option.id),
                  }
                : register(name, { required }))}
              id={option.id}
              value={option.id}
              type="radio"
              className="size-4 appearance-none rounded-full border border-ink-300 bg-white checked:!border-accent-500 checked:!bg-accent-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-500 disabled:border-ink-200 disabled:bg-ink-100 forced-colors:appearance-auto mt-0.5 transition-colors"
            />
            <label
              htmlFor={option.id}
              className="ml-3 block text-sm/6 font-medium text-ink-900"
            >
              <div className="font-medium">{option.title}</div>
              {option.description && (
                <div className="mt-0.5 text-sm font-normal text-ink-500">
                  {option.description}
                </div>
              )}
            </label>
          </div>
        ))}
      </div>
    </fieldset>
  );
};

export default RadioGroup;
